export default __webpack_public_path__ + "static/media/property_396.87e1a2bb.png";